<template>
  <div class="receipt-wrap">
    <div class="no-print print-actions">
      <button type="button" class="btn btn-primary" @click="doPrint">
        <b-icon icon="printer"></b-icon> {{ $t('Чоп этиш') }}
      </button>
      <button type="button" class="btn btn-secondary" @click="closeWin">
        {{ $t('Ёпиш') }}
      </button>
    </div>

    <div id="receipt" class="receipt">
      <div class="rcpt-center" v-if="printer && printer.file_name">
        <img :src="axiosBase + '/api/v1/uploads/' + printer.file_name" class="rcpt-logo" />
      </div>
      <div class="rcpt-center rcpt-title" v-if="mysklad">
        <b>{{ mysklad.name }}</b>
      </div>
      <div class="rcpt-center" v-if="mysklad && mysklad.address">
        {{ $t('Манзил') }}: {{ mysklad.address }}
      </div>
      <div class="rcpt-center" v-if="mysklad && mysklad.phone_number">
        {{ $t('Телефон') }}: {{ mysklad.phone_number }}
      </div>

      <div class="rcpt-hr"></div>

      <div class="rcpt-center rcpt-doc">
        <b>{{ $t('ПРИХОД') }} №{{ datas.number }}</b>
      </div>
      <div class="rcpt-row" v-if="datas.created_at">
        <span>{{ $t('Сана') }}:</span>
        <span>{{ Datetime(datas.created_at) }}</span>
      </div>
      <div class="rcpt-row" v-if="kontragent">
        <span>{{ $t('Етказувчи') }}:</span>
        <span><b>{{ kontragent.name }}</b></span>
      </div>
      <div class="rcpt-row" v-if="kontragent && kontragent.phone_number">
        <span>{{ $t('Телефон') }}:</span>
        <span>{{ kontragent.phone_number }}</span>
      </div>
      <div class="rcpt-row" v-if="kontragent && kontragent.address">
        <span>{{ $t('Манзил') }}:</span>
        <span>{{ kontragent.address }}</span>
      </div>
      <div class="rcpt-row" v-if="datas.user">
        <span>{{ $t('Ходим') }}:</span>
        <span>{{ datas.user.first_name }}</span>
      </div>

      <div class="rcpt-hr"></div>

      <div class="rcpt-items" v-if="datas.prixod_table">
        <div class="rcpt-item" v-for="(item, index) in datas.prixod_table" :key="index">
          <div class="rcpt-item-name">
            {{ index + 1 }}. <span v-if="item.product">{{ item.product.extra_name }}</span>
          </div>
          <div class="rcpt-item-calc">
            {{ item.count }} x {{ item.kontragent_price | numFormat }} =
            <b>{{ item.kontragent_summa | numFormat }}</b>
          </div>
        </div>
      </div>

      <div class="rcpt-hr"></div>

      <div class="rcpt-row">
        <span><b>{{ $t('Жами сумма') }}:</b></span>
        <span><b>{{ datas.summa | numFormat }}</b></span>
      </div>
      <div class="rcpt-row" v-if="datas.rasxod_summa > 0">
        <span>{{ $t('Расход') }}:</span>
        <span>{{ datas.rasxod_summa | numFormat }}</span>
      </div>
      <div class="rcpt-row" v-if="datas.skidka_summa > 0">
        <span>{{ $t('Скидка') }}:</span>
        <span>{{ datas.skidka_summa | numFormat }}</span>
      </div>

      <div class="rcpt-hr"></div>

      <div class="rcpt-row" v-if="kontragent && qarz != 0">
        <span><b>{{ $t('Қолдиқ сумма') }}:</b></span>
        <span><b>{{ qarz | numFormat }}</b></span>
      </div>
      <div class="rcpt-row" v-if="kontragent && qarz_dollar != 0">
        <span><b>{{ $t('Қолдиқ сумма') }} $:</b></span>
        <span><b>{{ qarz_dollar | numFormat }}</b></span>
      </div>

      <div class="rcpt-hr"></div>

      <div class="rcpt-sign">
        <div class="rcpt-sign-row">
          <span>{{ $t('Топширди') }}:</span>
          <span class="rcpt-sign-line"></span>
        </div>
        <div class="rcpt-sign-row">
          <span>{{ $t('Қабул қилди') }}:</span>
          <span class="rcpt-sign-line"></span>
        </div>
      </div>

      <div class="rcpt-center rcpt-footer" v-if="mysklad && mysklad.check_word">
        {{ mysklad.check_word }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KirimPrint",
  data() {
    return {
      datas: { prixod_table: [], summa: 0, rasxod_summa: 0, skidka_summa: 0, number: '', created_at: 0 },
      mysklad: null,
      kontragent: null,
      printer: {},
      qarz: 0,
      qarz_dollar: 0,
      axiosBase: (axios && axios.defaults && axios.defaults.baseURL) ? axios.defaults.baseURL : '',
      autoPrinted: false,
      ready: { data: false, sklad: false, qarz: false }
    };
  },
  created() {
    this.GetPrinterName();
    this.GetData();
  },
  methods: {
    GetPrinterName() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/sklad-settings",
        data: { sklad_id: localStorage.getItem('sklad_id'), key: 'a4_printer' }
      }).then(function (response) {
        if (response.data.data != null) {
          self.printer = JSON.parse(response.data.data);
        }
      }).catch(function () {});
    },
    GetData() {
      let self = this;
      axios.get("api/v1/prixod/id/" + self.$route.params.id).then(function (response) {
        self.datas = response.data;
        self.ready.data = true;
        self.GetSklad();
        if (response.data.kontragent_id > 0) {
          self.GetKontragent(response.data.kontragent_id);
        }
        self.GetQarz();
      });
    },
    GetSklad() {
      let self = this;
      axios.get("api/v1/sklads/id/" + self.datas.sklad_id).then(function (response) {
        self.mysklad = response.data;
        self.ready.sklad = true;
        self.tryAutoPrint();
      });
    },
    GetKontragent(id) {
      let self = this;
      axios.get("api/v1/kontragent/id/" + id).then(function (response) {
        self.kontragent = response.data;
      });
    },
    GetQarz() {
      let self = this;
      axios({
        method: "post",
        url: "api/v1/kontragent/total",
        data: {
          kontragent_id: self.datas.kontragent_id,
          sklad_id: self.datas.sklad_id,
          datetime: self.datas.created_at
        }
      }).then(function (response) {
        (response.data || []).forEach(function (key) {
          if (key.pay_type_id == 3) {
            self.qarz_dollar = key.total;
          } else {
            self.qarz = key.total;
          }
        });
        self.ready.qarz = true;
        self.tryAutoPrint();
      }).catch(function () {
        self.ready.qarz = true;
        self.tryAutoPrint();
      });
    },
    Datetime(date) {
      var d = new Date(date * 1000);
      var dt = d.getDate();
      var month = d.getMonth() + 1;
      var hour = d.getHours();
      var minut = d.getMinutes();
      if (month < 10) month = "0" + month;
      if (dt < 10) dt = "0" + dt;
      if (hour < 10) hour = "0" + hour;
      if (minut < 10) minut = "0" + minut;
      return dt + "." + month + "." + d.getFullYear() + " " + hour + ":" + minut;
    },
    tryAutoPrint() {
      if (this.autoPrinted) return;
      if (this.ready.data && this.ready.sklad && this.ready.qarz) {
        this.autoPrinted = true;
        this.$nextTick(() => {
          setTimeout(() => { this.doPrint(); }, 500);
        });
      }
    },
    doPrint() {
      window.print();
    },
    closeWin() {
      window.close();
    }
  }
};
</script>

<style scoped>
.receipt-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f1f5f9;
  min-height: 100vh;
  padding: 20px 0;
}
.print-actions {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}
.print-actions .btn {
  padding: 8px 18px;
  font-weight: 600;
  border-radius: 8px;
}
.receipt {
  width: 80mm;
  max-width: 80mm;
  background: white;
  padding: 8px 10px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
  color: #000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.rcpt-center {
  text-align: center;
  margin: 2px 0;
}
.rcpt-title {
  font-size: 14px;
  margin: 4px 0;
}
.rcpt-doc {
  font-size: 13px;
  margin: 4px 0;
}
.rcpt-logo {
  max-width: 120px;
  max-height: 60px;
}
.rcpt-hr {
  border-top: 1px dashed #000;
  margin: 4px 0;
}
.rcpt-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin: 2px 0;
  word-break: break-word;
}
.rcpt-items {
  margin: 2px 0;
}
.rcpt-item {
  margin: 4px 0;
}
.rcpt-item-name {
  font-weight: 600;
}
.rcpt-item-calc {
  text-align: right;
}
.rcpt-sign {
  margin-top: 10px;
}
.rcpt-sign-row {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  margin: 14px 0 4px;
}
.rcpt-sign-line {
  flex: 1;
  border-bottom: 1px solid #000;
  height: 1px;
}
.rcpt-footer {
  margin-top: 8px;
  font-style: italic;
}

@media print {
  @page {
    size: 80mm auto;
    margin: 0;
  }
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
  }
  .receipt-wrap {
    background: white;
    padding: 0;
    min-height: auto;
  }
  .no-print,
  .print-actions {
    display: none !important;
  }
  .receipt {
    width: 80mm;
    max-width: 80mm;
    box-shadow: none;
    padding: 2mm 3mm;
  }
}
</style>
